import { useState } from 'react'

function MedicationPrn({ items, canEdit, onAdminister }) {
  const [reasonFor, setReasonFor] = useState(null)
  const [reason, setReason] = useState('')

  return (
    <section className="med-prn">
      <h3>Intercorrência / se necessário</h3>
      {!items.length && <p className="patients-muted">Nenhum medicamento sem horário fixo.</p>}
      <div className="med-prn-list">
        {items.map((item) => (
          <article key={item.id} className="med-rx-item med-prn-row">
            <div>
              <strong>{item.name}</strong>
              <p className="patients-muted">Prescrito: {item.prescribed_by_name || 'não informado'}</p>
              {item.today_count > 0 && <p className="patients-muted">Hoje: {item.today_count} administração{item.today_count === 1 ? '' : 'ões'}</p>}
            </div>
            {canEdit && reasonFor !== item.id && (
              <button type="button" className="patients-btn patients-btn--primary patients-btn--compact" onClick={() => { setReasonFor(item.id); setReason('') }}>
                Administrar agora
              </button>
            )}
            {canEdit && reasonFor === item.id && (
              <form
                className="med-stock-form"
                onSubmit={(event) => {
                  event.preventDefault()
                  if (!reason.trim()) return
                  onAdminister(item, reason.trim())
                  setReasonFor(null)
                  setReason('')
                }}
              >
                <input value={reason} onChange={(event) => setReason(event.target.value)} placeholder="Motivo ou sintoma" />
                <button type="submit" className="patients-btn patients-btn--primary patients-btn--compact">Registrar</button>
              </form>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}

export default MedicationPrn
